// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeader_wrapper__LRQJl","title":"SectionHeader_title__IaFDV","link":"SectionHeader_link__L9np-"};